<template>
  <div class="animated fadeIn">
    <b-tabs card>
      <b-tab title="Analyses" active>
        <h3>Analyses</h3>
        <analysis-server-table
          :show_columns="[
            'name',
            'modus_name',
            'extraction_method',
            'measurement_method'
          ]"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import AnalysisServerTable from "@/components/lab/analysis/AnalysisServerTable";

export default {
  name: "AnalyteDetailCardstack",
  components: {
    AnalysisServerTable
  }
};
</script>
